import { useGetTransactionReversalQuery } from "@/services/transactionReversal";
import { useGetFilteredStoresQuery } from "@/services/store/store";
import { toast } from "components/ui/use-toast";
import { useEffect, useState } from "react";
import { useFilterActions } from "../ducks/filter/hooks/action";
import { useFilterState } from "../ducks/filter/hooks/filterState";
import { columns } from "./components/columns";
import { DataTable } from "./components/data-table";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { MainFilters } from "./components/filters/MainFilters";
import { Load } from "components/load";

export default function TransactionReversalScreen() {
  const filterState = useFilterState();
  const [hasError, setHasError] = useState(false);

  const { data: storesData, isLoading: isLoadingStores } = useGetFilteredStoresQuery({
    onlyStoreFortyTree: "true",
    perPage: 300,
    page: 1,
  });

  const { store, date, operationType, paymentType } =
    filterState?.filters?.advancedFilter || {};
  const isSearch = store || date || operationType || paymentType;

  const { data, isFetching, error } = useGetTransactionReversalQuery(
    {
      filters: {
        ...(filterState?.filters?.advancedFilter?.store !== undefined && {
          storeId: filterState?.filters?.advancedFilter?.store,
        }),
        ...(filterState?.filters?.advancedFilter?.operationType !==
          undefined && {
          operationType: filterState?.filters?.advancedFilter?.operationType,
        }),
        ...(filterState?.filters?.advancedFilter?.paymentType !== undefined && {
          paymentType: filterState?.filters?.advancedFilter?.paymentType,
        }),
        ...(filterState?.filters?.advancedFilter?.date !== undefined && {
          date: filterState?.filters?.advancedFilter?.date,
        }),
        ...(filterState?.filters?.advancedFilter?.cardNumber !== undefined && {
          cardNumber: filterState?.filters?.advancedFilter?.cardNumber,
        }),
        ...(filterState?.filters?.advancedFilter?.nsuNumber !== undefined && {
          authorizationNsu: filterState?.filters?.advancedFilter?.nsuNumber,
        }),
        ...(filterState?.filters?.advancedFilter?.nsuNetwork !== undefined && {
          networkNsu: filterState?.filters?.advancedFilter?.nsuNetwork,
        }),
        ...(filterState?.filters?.advancedFilter?.operationNumber !==
          undefined && {
          operationNumber:
            filterState?.filters?.advancedFilter?.operationNumber,
        }),
        ...(filterState?.filters?.advancedFilter?.couponNumber !==
          undefined && {
          couponNumber: filterState?.filters?.advancedFilter?.couponNumber,
        }),
        ...(filterState?.filters?.advancedFilter?.salesControlNumber !==
          undefined && {
          salesControlNumber:
            filterState?.filters?.advancedFilter?.salesControlNumber,
        }),
        ...(filterState?.filters?.advancedFilter?.finalValue !== undefined && {
          finalValue: filterState?.filters?.advancedFilter?.finalValue,
        }),
        ...(filterState?.filters?.advancedFilter?.initialValue !==
          undefined && {
          initialValue: filterState?.filters?.advancedFilter?.initialValue,
        }),
        ...(filterState?.filters?.advancedFilter?.isOnly1InSequence !==
          undefined && {
          isOnly1InSequence: filterState?.filters?.advancedFilter?.isOnly1InSequence,
        }),
        page: filterState?.filters?.meta?.page ?? 1,
        perPage: filterState?.filters?.meta?.perPage ?? 10,
      },
    },
    { skip: !isSearch || hasError }
  );

  const { updateFilter } = useFilterActions();

  useEffect(() => {
    updateFilter({
      key: "meta",
      value: { page: 1 },
    });
    setHasError(false);
  }, [filterState?.filters?.advancedFilter]);

  useEffect(() => {
    if (error) {
      setHasError(true);
      toast({
        variant: "destructive",
        description:
          "Ocorreu um erro inesperado ao buscar as movimentações. Tente novamente mais tarde.",
        duration: 5000,
      });
    }
  }, [error]);

  if (isLoadingStores) {
    return (
      <PageLayout>
        <PageTitle
          title="Estorno de Movimentação"
          description="Estorna a movimentação desejada"
        />
        <ContentContainer>
          <div className="flex items-center justify-center h-64">
            <Load />
          </div>
        </ContentContainer>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <PageTitle
        title="Estorno de Movimentação"
        description="Estorna a movimentação desejada"
      />
      <ContentContainer>
        {/* Filtros principais fixos */}
        <MainFilters storesData={storesData?.data || []} />

        {/* Tabela de dados */}
        <div className="relative w-full">
          {isFetching && (
            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
              <svg
                className="animate-spin h-12 w-12 text-primary"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </div>
          )}
          <DataTable
            data={(data as any)?.data ?? []}
            columns={columns}
            meta={(data as any)?.meta}
          />
        </div>
      </ContentContainer>
    </PageLayout>
  );
}